import { Route, Routes, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Private from "./components/Private";
import Home from "./pages/Home";
import 'react-toastify/dist/ReactToastify.css';
import Sidebar from "./components/Sidebar";
import { Box, useMediaQuery } from "@mui/material";
import Navbar from "./components/Navbar";
import { LocalStore } from "./storage/authStore";
import Category from "./pages/Category";
import LocationPage from "./pages/Location";
import WebSubCategory from "./pages/WebCategory/SubCategoryList";
import LocationContentManagement from "./pages/WebCategory/LocationContentManagement";
import BulkImportWebCategory from "./pages/WebCategory/BulkImportWebCategory";
import BulkImportWebCategoryList from "./pages/WebCategory/BulkImportWebCategoryList";
import Brand from './pages/Brand'
import Service from "./pages/MasterService";
import Provider from "./pages/Provider";
import ProviderWallet from "./pages/ProviderWallet";
import UserProfile from "./pages/Provider/UserProfile";
import ViewProfile from "./pages/Provider/viewProfile";
import Customer from "./pages/Customer";
import Booking from "./pages/Booking";
import ForgotPassword from "./pages/ForgotPassword";
import Member from "./pages/Settings/members/index";
import Role from "./pages/Settings/roles";
import { ProtectedRoute } from "./components/ProtectedRoute";
import UnauthorizedPage from "./pages/UnAuthorized";
import Feature from "./pages/Settings/features/index";
import LoggedUserProfile from "./pages/Logged";
import ViewCustomerProfile from "./pages/Customer/CustomerProfile";
import RewardPrograms from "./pages/Marketing/rewardPrograms";
import AddEditService from "./pages/MasterService/AddEditService";
import Banners from "./pages/Marketing/banners";
import { useTheme } from "@emotion/react";
import Business from "./pages/Settings/business";
import AddBooking from "./pages/Booking/AddBooking/AddBooking";
import UpdateBooking from "./pages/Booking/UpdateBooking/UpdateBooking";
import BookingDetails from "./pages/Booking/viewDetails/Bookingdetails";
import MyOperatorDashboard from "./pages/MyOperatorDashboard";
import MainContentLayout from "./components/Layout/MainContentLayout";
import Coupons from "./pages/Marketing/coupons";
import ExpertMapView from "./pages/Provider/expertMap";
import GeoExpertView from "./pages/Provider/geo-expert";
import AbandonedCart from "./pages/Marketing/abandonedCart";
import Tools from "./pages/Tools";
import AddEditCustomer from "./pages/Customer/AddEditStepwise/AddEditCustomer";
import Lyns from "./pages/Lyns";
import Media from "./pages/Media";
import VideoPage from "./pages/Media/uploadMedia/Video/VideoPage";
import UploadMedia from "./pages/Media/uploadMedia";
import CudelChats from "./pages/Chats";
import MaterializedView from "./pages/Settings/materializedView";
import NotificationModule from "./pages/Notification/notification_new";
import EnumSettings from "./pages/Notification/EnumSettings";
import ViewNotification from "./pages/Notification/notification_new/ViewNotification";
import Notification from "./pages/Notification/notification_old";
import BookingPayment from "./pages/Payment/Booking/BookingPayment";
import Subscription from "./pages/Settings/Subscription";
import TestingInterface from "./pages/Testing";
import HomeScreen from "./pages/CustomerApp/HomeScreen";
import SectionList from "./pages/CustomerApp/HomeScreen/Section/SectionList";
import AddEditSection from "./pages/CustomerApp/HomeScreen/Section/AddEditSection";
import ViewSection from "./pages/CustomerApp/HomeScreen/Section/ViewSection";
import AddEditSectionItem from "./pages/CustomerApp/HomeScreen/SectionItem/AddEditSectionItem";
import ViewSectionItem from "./pages/CustomerApp/HomeScreen/SectionItem/ViewSectionItem";
import SectionItems from "./pages/CustomerApp/HomeScreen/SectionItem/SectionItems";
import NotificationLog from "./pages/Notification/logs";
import TaxReportIndex from "./pages/Reports/TaxReport";
import GuideLines from "./pages/Guidelines";
import ExpertPayout from "./pages/Reports/ExpertPayout/ExpertPayout";
import GenerateDeepLink from "./pages/GenerateDeepLink";
import DeepLinkList from "./pages/GenerateDeepLink/DeepLinkList";
import Analytics from "./pages/Analytics";
import HeaderManagement from "./pages/CustomerApp/HomeScreen/HeaderManagement";
import Sections from "./pages/CustomerApp/HomeScreen/Section/Sections";
import Testimonials from "./pages/Testimonials";
// import{ViewProfile as LoggedUserProfile} from "./pages/AdminUser/UserProfile";


// Auth Route component to prevent accessing login pages when already authenticated
const AuthRoute = ({ element }) => {
  const isLogin = LocalStore.isLogin();
  if (isLogin) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return element;
};

function App() {
  const theme = useTheme();
  const downMd = useMediaQuery(theme.breakpoints.down('md'));
  const downSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isLogin = LocalStore.isLogin();
  // const userDetail = LocalStore.getCurrentUserDetails();
  // const role = userDetail ? userDetail.role : 0;

  return (
    <>
      <Box className={isLogin ? 'bodyBgColor' : ''} sx={{ mt: { xs: '3.5rem', sm: '4rem' } }}>
        {isLogin && <Navbar />}
        <Box sx={{ display: !downSm && "flex" }}>
          {!downMd && isLogin && <Sidebar />}
          <MainContentLayout>
            <Routes>
              {/* Auth Routes - Protected from logged-in users */}
              <Route path="/" element={<AuthRoute element={<Login />} />} />
              <Route path="/login" element={<AuthRoute element={<Login />} />} />
              <Route path="/forgot-password" element={<AuthRoute element={<ForgotPassword />} />} />
              <Route path="/unauthorized" element={<UnauthorizedPage />} />


              <Route path="/admin" element={<Private />}>

                {/* =====================Dashboard ===================*/}
                <Route path="" element={<Home />} />
                <Route path="dashboard" element={<Home />} />

                {/* =====================Guidelines ===================*/}
                <Route path="guidelines" element={<GuideLines />} />

                {/* =====================Analytics ===================*/}
                <Route path="analytics" element={<Analytics />} />


                {/* ==================Booking Management ===================*/}
                <Route path="booking" element={<Private />}>
                  <Route path="" element={
                    <ProtectedRoute feature="booking" element={<Booking />} />
                  } />
                  <Route path="new" element={
                    <ProtectedRoute feature="booking" element={<AddBooking />} />
                  } />
                  <Route path="modify/:id" element={
                    <ProtectedRoute feature="booking" element={<UpdateBooking />} />
                  } />

                  <Route path="chats" element={
                    <ProtectedRoute feature="booking" element={<CudelChats />} />
                  } />
                  <Route path="payment" element={
                    <ProtectedRoute feature="booking" element={<BookingPayment />} />
                  } />
                </Route>

                <Route path="booking-details/:bookingId" element={
                  <ProtectedRoute feature="booking" element={<BookingDetails />} />
                } />
                <Route path="myoperator" element={
                  <ProtectedRoute feature="myoperator" element={<MyOperatorDashboard />} />
                } />
                {/* ====================Customer Management ========================*/}
                <Route path="customers" element={
                  <ProtectedRoute feature="customer" element={<Customer />} />
                } />
                <Route path="customer/:id" element={
                  <ProtectedRoute feature="customer" element={<AddEditCustomer />} />
                  // <ProtectedRoute feature="customer" element={<AddEditProfile />} />
                } />
                <Route path="customerProfile/:id" element={
                  <ProtectedRoute feature="customer" element={<ViewCustomerProfile />} />
                } />

                {/* ===================Brand Management =================*/}
                <Route path="brand" element={
                  <ProtectedRoute feature="brand" element={<Brand />} />
                } />


                {/* ===================Category Management =================*/}
                <Route path="category" element={
                  <ProtectedRoute feature="category" element={<Category />} />
                } />

                {/* ===================SEO Pages Management =================*/}
                <Route path="web-subcategory" element={<WebSubCategory />} />
                <Route path="web-category-import" element={<BulkImportWebCategory />} />
                <Route path="web-category-import/edit/:id" element={<BulkImportWebCategory />} />
                <Route path="web-category-import-list" element={<BulkImportWebCategoryList />} />
                <Route path="web-location-content" element={<LocationContentManagement />} />

                {/* ===================Location Management =================*/}
                <Route path="locations" element={<LocationPage />} />


                {/* ===================Service Management =================*/}
                <Route path="services" element={
                  <ProtectedRoute feature="service" element={<Service />} />
                } />

                <Route path="service/:id" element={
                  <ProtectedRoute feature="service" element={<AddEditService />} />
                } />

                <Route path="service-details/:id" element={
                  <ProtectedRoute feature="service" element={<Service />} />
                } />

                {/* ========== logged user Management ============== */}
                <Route path="logged/userProfile" element={<LoggedUserProfile />} />

                {/* ====================Product Management ========================*/}

                {/* ===============User/Provider Management ==============*/}
                <Route path="users" element={<Private />}>
                  <Route path="" element={
                    <ProtectedRoute feature="service-expert" element={<Provider />} />
                  } />
                  <Route path="wallet" element={
                    <ProtectedRoute feature="service-expert" element={<ProviderWallet />} />
                  } />

                </Route>
                <Route path="expert-detail/:id/:step?" element={
                  <ProtectedRoute feature="service-expert" element={<ViewProfile />} />
                } />

                <Route path="userProfile/:id/:step?" element={<UserProfile />} />
                {/* <Route path="logged/userProfile/:id" element={<LoggedUserProfile />} /> */}

                <Route path="report" element={<Private />}>
                  {/* <Route path ='' element={<Reports/>}/> */}
                  <Route path="tax-report" element={
                    <ProtectedRoute feature="tax-report" element={<TaxReportIndex />} />
                  } />
                  <Route path="expert-payout" element={<ExpertPayout />} />
                </Route>

                <Route path="experts-map" element={<ExpertMapView />} />
                <Route path="geo-expert" element={<GeoExpertView />} />
              </Route>

              {/* Settings Routes */}
              <Route path="/settings" element={<Private />}>
                <Route path="members" element={
                  <ProtectedRoute feature="register-admin" element={<Member />} />
                } />
                {/* <Route path="member/:id" element={
                  <ProtectedRoute feature="register-admin" element={<AddMember />} />
                } /> */}
                <Route path="roles" element={
                  <ProtectedRoute feature="roles-and-permissions" element={<Role />} />
                } />
                {/* <Route path="role/view/:id" element={
                  <ProtectedRoute feature="roles-and-permissions" element={<ViewRole />} />
                } /> */}
                <Route path="features" element={
                  <ProtectedRoute feature="roles-and-permissions" element={<Feature />} />
                } />


                {/* tab is optional */}

                <Route path="business/:tab?" element={<Business />
                  // <ProtectedRoute feature="roles-and-permissions" element={<Feature />} />
                } />
                <Route path="materialize-view" element={<MaterializedView />} />
                {/* <Route path="subscription" element={
                  <ProtectedRoute feature="roles-and-permissions" element={<Feature />} />
                } /> */}
                <Route path="subscription" element={<Subscription />} />
                <Route path="locations" element={<Subscription />} />

              </Route>

              <Route path="/marketing" element={<Private />}>
                <Route path="coupons" element={<Coupons />} />
                <Route path="coupon/:id" element={<Coupons />} />
                <Route path="coupon/view/:id" element={<Coupons />} />
                <Route path="abandoned-cart" element={<AbandonedCart />} />
                {/* <Route path='notification' element={<Notification/>} /> */}
                <Route path="reward-programs" element={<RewardPrograms />
                  // <ProtectedRoute feature="roles-and-permissions" element={<Feature />} />
                } />

                <Route path="banners" element={<Banners />
                  // <ProtectedRoute feature="roles-and-permissions" element={<Feature />} />
                } />
                <Route path="testimonials" element={<Testimonials/>
                  } />
                <Route path="banner/:id" element={<Banners />
                  // <ProtectedRoute feature="roles-and-permissions" element={<Feature />} />
                } />
                <Route path="banner/view/:id" element={<Banners />
                  // <ProtectedRoute feature="roles-and-permissions" element={<Feature />} />
                } />
              </Route>
              <Route path="/notification" element={<Private />}>
                {/* <Route path="coupons" element={<Coupons />} />
                <Route path="coupon/:id" element={<Coupons />} />
                <Route path="coupon/view/:id" element={<Coupons />} />
                <Route path="abandoned-cart" element={<AbandonedCart />} /> */}
                <Route path='' element={<NotificationModule />} />
                <Route path=':id' element={<ViewNotification />} />
                <Route path='old' element={<Notification />} />
                <Route path='enum-settings' element={<EnumSettings />} />
                <Route path='whatsapp/log' element={<NotificationLog />} />

              </Route>
              <Route path="/testing" element={<Private />}>
                <Route path="" element={<TestingInterface />} />
                {/* <Route path="coupons" element={<Coupons />} />
                <Route path="coupon/:id" element={<Coupons />} />
                <Route path="coupon/view/:id" element={<Coupons />} />
                <Route path="abandoned-cart" element={<AbandonedCart />} /> */}
                {/* <Route path='notification' element={<NotificationModule/>} />
                <Route path='notification/:id' element={<ViewNotification/>} />
                <Route path='experts' element={<Experts/>} /> */}
              </Route>
              <Route path="/lyns" element={<Private />}>
                <Route path="" element={
                  <ProtectedRoute feature="lyns" element={<Lyns />} />
                } />
              </Route>

              {/* ==================Media Management ===================*/}
              <Route path="/admin/media" element={<Private />}>
                <Route path="all" element={<Media />} />
                <Route path="upload" element={<UploadMedia />} />
                <Route path="upload/:tab" element={<UploadMedia />} />
              </Route>
              <Route path="/tools" element={<Private />}>
                <Route path="" element={<Tools />} />
              </Route>

              <Route path="/customer-app/generate-deep-link" element={<DeepLinkList />}></Route>
              <Route path="/customer-app/generate-deep-link/create" element={<GenerateDeepLink />}></Route>
              <Route path="/customer-app/header-management" element={<HeaderManagement />}></Route>
              <Route path="/customer-app/footer-management" element={<HeaderManagement />}></Route>
              <Route path="/customer-app/sections" element={<Sections />}></Route>

              <Route path="/customer-app/home-screen" element={<Private />}>

                <Route path="" element={<HomeScreen />} />
                <Route path="section" element={<HomeScreen />} />
                <Route path="section/:id" element={<AddEditSection />} />
                <Route path="section/view/:id" element={<ViewSection />} />
                <Route path="section-item" element={<HomeScreen />} />
                <Route path="section-items" element={<SectionItems />} />
                <Route path="section-items/:sectionId" element={<SectionItems />} />
                <Route path="section-item/view/:id" element={<ViewSectionItem />} />
                <Route path="section-item/:id" element={<AddEditSectionItem />} />
             




                {/* <Route path="sections" element={<CustomerAppSections />} />
                <Route path="home-screen/:sectionId" element={
                  <ProtectedRoute feature="customer-app" element={<AddEditSection />} />
                } />
                <Route path="home-screen/view/:sectionId" element={
                  <ProtectedRoute feature="customer-app" element={<ViewSection />} />
                } />
                <Route path="home-screen/items/:sectionId" element={
                  <ProtectedRoute feature="customer-app" element={<CustomerAppItems />} />
                } />
                <Route path="home-screen/items/:sectionId/add" element={
                  <ProtectedRoute feature="customer-app" element={<AddEditItem />} />
                } />
                <Route path="home-screen/items/:sectionId/:itemId" element={
                  <ProtectedRoute feature="customer-app" element={<AddEditItem />} />
                } />
                <Route path="home-screen/items/view/:sectionId/:itemId" element={
                  <ProtectedRoute feature="customer-app" element={<ViewItem />} />
                } /> */}
              </Route>


            </Routes>
          </MainContentLayout>
        </Box>
      </Box>
    </>
  );
}

export default App;
